import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_SPESE_GENERALI_LIST } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storeSpeseGeneraliListAction,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const retrieveSpeseGeneraliListEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_SPESE_GENERALI_LIST),
    map(() => ({
      page: 1,
      pageSize: rootConfig.populateFields,
      order: [['nome', 'asc']],
    })),
    // tap(p => console.log(`[epic ${RETRIEVE_SPESE_GENERALI_LIST}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ onorarioLoader: true })),
        of(setListConfigAction({ role: body })),
        defer(() =>
          from(
            request({
              path: `speseGenerali/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_SPESE_GENERALI_LIST}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storeSpeseGeneraliListAction(data))),
            catchError(err => {
              console.error(
                `[epic ${RETRIEVE_SPESE_GENERALI_LIST}] error`,
                err
              );
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ onorarioLoader: false }))
      );
    })
  );

export default retrieveSpeseGeneraliListEpic;
